(function () {

    angular
        .module('smartertoolsApp')
        .controller('resellersPricingTableController', ['resellersService', resellersPricingTableController]);

    function resellersPricingTableController(resellersService) {
        const vm = this;
        vm.pricingTable = null;
        vm.isLoading = true;
        vm.loadingError = null;

        // Functions
        vm.getPricingTableCsvHeader = getPricingTableCsvHeader;
        vm.getPricingTableCsvData = getPricingTableCsvData;
        vm.refreshData = refreshData;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.refreshData();
        }

        function getPricingTableCsvHeader() {
            return ['Category', 'ID', 'Product', 'Suggested Retail Price', 'Minimum Retail Price', 'Monthly Cost to You'];
        }

        function getPricingTableCsvData() {
            const items = [];
            for (let i = 0; i < vm.pricingTable.length; i++) {
                const category = vm.pricingTable[i];
                for (let j = 0; j < category.Items.length; j++) {
                    const a = category.Items[j];
                    items.push({
                        category: category.CategoryName,
                        id: a.ProductId,
                        name: a.Name,
                        msrp: '$' + a.SuggestedRetailPrice,
                        mmrp: '$' + a.MinimumRetailPrice,
                        cost: '$' + a.CostToPartner
                    });
                }
            }
            return items;
        }

        function refreshData() {
            resellersService.getPricingTable()
                .then((categories) => {
                    vm.pricingTable = categories;
                    vm.isLoading = false;
                })
                .catch((e) => {
                    if (e.status == 403) {
                        window.location.href = '/company/partners';
                        return;
                    }
                    vm.loadingError = 'There was a problem loading this information.  Please try again later.';
                });
        }
    }
})();